import { IApplicationState } from '../../types/redux';

export function getIsReliable(state: IApplicationState): boolean {
  return state.newbuilding.isReliableV2 || false;
}
